import React, { ReactNode, useEffect } from 'react';

interface Props {
    isOpen: boolean;
    children: ReactNode;
    onClose: () => void;
    onSave?: () => void;
    onCancel?: () => void;
    isSaveHidden?: boolean;
    isSaveDisabled?: boolean;
    saveText?: string;
    cancelText?: string;
    headerText: string;
    isLoading?: boolean;
    onDelete?: () => void;
    isDeleteHidden?: boolean;
    size?: 'wider' | 'wide';
    isBackgroundWhite?: boolean;
    isWithFooter?: boolean;
    customHeader?: ReactNode;
    customerFooter?: ReactNode;
    bodyClassName?: string;
}

const Modal = ({
    isOpen,
    children,
    onClose,
    onSave,
    onCancel,
    isSaveHidden = false,
    isSaveDisabled = false,
    saveText,
    cancelText,
    headerText,
    customHeader,
    isLoading,
    onDelete,
    isDeleteHidden = false,
    size,
    isBackgroundWhite,
    isWithFooter = true,
    bodyClassName,
    customerFooter,
}: Props) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);
    return (
        <div
            className="modal"
            style={{
                transform: isOpen ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: isOpen ? 1 : 0,
                display: isOpen ? 'block' : 'none',
            }}
        >
            <div className={`modal-content ${size} rounded-lg shadow-2xl`}>
                <div className="p-3 flex bg-blue-600 rounded-t-lg">
                    {customHeader ? (
                        customHeader
                    ) : (
                        <>
                            <h2 className="text-lg text-white font-semibold">{headerText}</h2>
                            <div className="ml-auto clickable" onClick={onClose}>
                                ✖
                            </div>
                        </>
                    )}
                </div>
                <div className={`modal-body overflow-y-scroll ${isBackgroundWhite && 'bg-white'} ${bodyClassName}`}>
                    {!!isLoading && (
                        <div className="loading">
                            <div className="spinner"></div>
                        </div>
                    )}
                    {children}
                </div>

                {isWithFooter && (
                    <div className={`modal-footer ${isBackgroundWhite && 'bg-white'}`}>
                        {customerFooter ? (
                            customerFooter
                        ) : (
                            <div className="border-t border-gray-200 p-4 bg-gray-50 flex">
                                {onDelete && !isDeleteHidden && (
                                    <button
                                        className="px-4 py-2  border-red-600 text-red-500 font-semibold  rounded-md hover:bg-red-700  hover:bg-white hover:outline-1 hover:outline-red-500 hover:ring-1 hover:ring-red-500"
                                        onClick={onDelete}
                                    >
                                        Delete
                                    </button>
                                )}

                                <div className="flex justify-end space-x-3 ml-auto">
                                    <button
                                        className="px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-100"
                                        onClick={() => {
                                            if (onCancel) {
                                                onCancel();
                                            } else {
                                                onClose();
                                            }
                                        }}
                                    >
                                        {cancelText ? cancelText : 'Cancel'}
                                    </button>
                                    {onSave && !isSaveHidden && (
                                        <button
                                            className={`disabled:opacity-50  px-4 py-2 bg-green-600 text-white font-medium rounded-md  ${
                                                isSaveDisabled ? 'hover:cursor-not-allowed ' : 'hover:bg-green-700'
                                            }`}
                                            onClick={onSave}
                                            disabled={isSaveDisabled}
                                        >
                                            {saveText ? saveText : 'Save'}
                                        </button>
                                    )}
                                </div>
                            </div>
                            // <div className="flex p-2 border-t-2 ">
                            //     {onDelete && !isDeleteHidden && (
                            //         <span className="button-delete link warning" onClick={onDelete}>
                            //             Delete
                            //         </span>
                            //     )}
                            //     <button
                            //         className="ml-auto rounded-xl px-2 font-semibold border border-gray-500 bg-gray-400 mr-1"
                            //         onClick={() => {
                            //             if (onCancel) {
                            //                 onCancel();
                            //             } else {
                            //                 onClose();
                            //             }
                            //         }}
                            //     >
                            //         {cancelText ? cancelText : "Cancel"}
                            //     </button>
                            //     {onSave && !isSaveHidden && (
                            //         <button
                            //             className={`disabled:opacity-50  rounded-xl px-2 font-semibold border border-gray-500  bg-green-500 ${
                            //                 isSaveDisabled && 'cursor-wait'
                            //             }}`}
                            //             onClick={onSave}
                            //             disabled={isSaveDisabled}
                            //         >
                            //             {saveText ? saveText : 'Save'}
                            //         </button>
                            //     )}
                            // </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;
